/*
 * File: Loader.tsx
 * Project: rosita
 * -----
 * Last Modified: 18 Feb 2022 4:40:21 pm
 * -----
 * Copyright (c) 2022 Elegant Software Solutions All rights reserved.
 */

import { Col, Layout, Row, Typography } from 'antd';
import { InlineStylesModel } from 'models/InlineStylesModel';
import '../../styles/loaderStyle.less';

const { Content } = Layout;

const styles: InlineStylesModel = {
  content: {
    textAlign: 'center'
  },
  mainRow: {
    height: '40vh'
  },
  layout: {
    background: 'transparent'
  }
};

interface Props {
  loadingMessage?: string;
  medium?: boolean;
  small?: boolean;
}

export const Loader = ({ loadingMessage, medium, small }: Props): JSX.Element => {
  return (
    <Layout style={styles.layout}>
      <Content style={styles.content}>
        <Row justify="center" align="middle" style={loadingMessage ? { height: '20vh' } : medium ? { transform: 'scale(.7)' } : small ? { transform: 'scale(.3)' } : styles.mainRow}>
          <Col span={24} style={loadingMessage ? { height: 100 } : undefined}>
            <div className="loader loader--slideUp">
              <span className="loader-item">1</span>
              <span className="loader-item">2</span>
              <span className="loader-item">3</span>
              <span className="loader-item">4</span>
              <span className="loader-item">5</span>
              <span className="loader-item">6</span>
            </div>
          </Col>
          {loadingMessage && (
            <Col span={24}>
              <Typography.Text style={{ fontSize: 18, fontWeight: 600, color: 'rgba(0,0,0,.8)' }}>{loadingMessage}</Typography.Text>
            </Col>
          )}
        </Row>
      </Content>
    </Layout>
  );
};
